import { render, staticRenderFns } from "./merchantBalance.vue?vue&type=template&id=fd49b21a"
import script from "./merchantBalance.vue?vue&type=script&lang=ts"
export * from "./merchantBalance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports